<dashboard-dialog-frame [header]="'Edit layouts'" [dialogRef]='dialogRef' [actions]="actions">

	<div class='edit-layouts-dialog-content'>
		Editor go here...
	</div>

</dashboard-dialog-frame>